import React from 'react';

import { UiNotification } from '../../ui/ui-notification';

type Props = {
  title: string;
  messageBody: string;
  subtitle: string;
  onClose: () => void;
  actions: React.ReactNode | null;
};

export const RealTimeNotification = ({ title, subtitle, onClose, messageBody, actions }: Props) => (
  <UiNotification
    title={title}
    subtitle={subtitle}
    onClose={onClose}
    actions={actions}
    notificationBody={
      <div>{messageBody.length > 100 ? `${messageBody.slice(0, 100)}...` : messageBody}</div>
    }
  />
);
